import { FC, memo, useCallback } from 'react'
import Dropzone from 'react-dropzone'

import { Button } from 'ui/components/Buttons'

export const UploadButton: FC<{
  onUpload: (files: File[]) => Promise<void>
}> = memo((props) => {
  const { onUpload } = props

  const onUploadWrapper = useCallback((acceptedFiles) => onUpload(acceptedFiles), [onUpload])

  return (
    <Dropzone onDrop={onUploadWrapper} multiple={true}>
      {({ getRootProps, getInputProps }) => (
        <Button face="tertiary" onClick={onUploadWrapper} {...getRootProps()}>
          Upload
          <input {...getInputProps()} />
        </Button>
      )}
    </Dropzone>
  )
})
